"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _context = require("../form/context");
var _Compact = require("../space/Compact");
const getInputAddon = addon => addon ? ( /*#__PURE__*/_react.default.createElement(_Compact.NoCompactStyle, null, /*#__PURE__*/_react.default.createElement(_context.NoFormStyle, {
  override: true,
  status: true
}, addon))) : null;
var _default = exports.default = getInputAddon;